<template>
  <main class="tw-px-4 tw-pt-11 tw-pb-4">
    <main-content-layout :title="$gettext('APPLICANT_REAL_ESTATE')">
      <template #buttons>
        <div class="tw-flex tw-gap-4 tw-sticky tw-top-0 tw-z-10 tw-bg-white">
          <!-- TODO: Futuramente esses botões serão ativados -->
          <!-- <q-btn
            color="grey-5"
            class="btn-header"
            @click="onSearschServiceRequest"
            :label="$gettext('SEARCH')"
          />
          <q-btn
            color="grey-5"
            class="btn-header"
            @click="onSearschServiceRequest"
            :label="$gettext('OWNERSHIP')"
          /> -->
          <q-btn
            :disable="selected.length != 1"
            :class="`${'btn-header'} ${
              selected.length != 1 ? 'grey-5' : 'bg-secondary text-white'
            }`"
            @click="onServiceRequest"
            icon-right="send"
            :label="$gettext('ATTEND')"
          />
          <q-btn
            class="btn-header bg-secondary text-white"
             icon="filter_list" @click="openFilterModal"
            :label="$gettext('FILTER')"
          />
        </div>
      </template>
      <aside class="tw-flex tw-flex-col tw-relative" style="height: 79vh">
        <header class="tw-flex tw-w-full tw-items-center tw-px-4 tw-text-gray-600" style="height: 8vh; gap: 45px">
          <span>
            <strong>{{ $gettext("PROTOCOL") }}</strong
            >: {{ protocol }}
          </span>
          <span>
            <strong>{{ getLabelInput("clientID") }}</strong>
            {{ state.serviceRequests[protocol].clientID }}
          </span>
          <span>
            <strong>{{ getLabelInput("clientName") }}</strong>
            {{ state.serviceRequests[protocol].clientName }}
          </span>
        </header>

        <div class="tw-flex tw-flex-grow tw-w-full tw-px-4 tw-overflow-auto">
          <jt-data-table
            v-if="state.serviceRequests[protocol].consumerUnits"
            singleselect
            :api-mode="false"
            class="tw-w-full tw-h-full"
            :data="Object.values(state.serviceRequests[protocol].consumerUnits)"
            :fields="colunasTabela"
            row-key="id"
            :is-paginated="false"
            :title="titleTeble"
            row-buttons
            @selection="onSelectedRow"
          >
            <template #header="{ props }">
              <q-tr :props="props" class="table-header">
                <q-td auto-width/>
                <q-td auto-width/>
                <q-td v-for="col in props.cols" :key="col.name" :props="props">
                  {{ col.label }}
                </q-td>
              </q-tr>
            </template>
            <template #body="{ props }">
              <q-tr :props="props">
                <q-td>
                  <q-checkbox v-model="props.selected" color="primary" :data-testid= "props.key"/>
                </q-td>
                <q-td auto-width>
                  <div class="tw-flex tw-gap-2">
                    <span
                      :class="props.row.debtIcon ?
                       'material-icons tw-text-red-500 tw-text-xl'
                       : 'material-icons tw-text-gray-400 tw-text-xl'"
                      >plocal_atm</span>
                    <span
                      :class="props.row.debtOldIcon ?
                       'material-icons tw-text-red-500 tw-text-xl'
                       : 'material-icons tw-text-gray-400 tw-text-xl'"
                      >people</span
                    >
                    <span
                      class="material-icons tw-text-gray-400 tw-text-xl"
                      >gavel</span
                    >
                  </div>
                </q-td>
                <q-td
                  v-for="col in props.cols"
                  style=""
                  :key="col.name"
                  :props="props"
                >
                  <span v-if="col.name == 'address'">
                    {{printAddress(props)}}
                  </span>
                  <span v-else>
                    {{ col.value }}
                  </span>

                  <q-btn
                    flat
                    round
                    v-if="col.name === 'showhide'"
                    color="primary"
                    :icon="
                      props.expand ? 'keyboard_arrow_up' : 'keyboard_arrow_down'
                    "
                    @click="props.expand = !props.expand"
                  />
                </q-td>
              </q-tr>
            </template>
          </jt-data-table>
        </div>
        <div
          class="tw-flex tw-items-center tw-justify-center tw-w-full"
          style="height: 10vh"
        >
          <q-btn
            class="btn-close-call btn-header"
            @click="controller.finishBegin({ protocol: protocol })"
          >
            <q-icon name="mdi-close-circle" class="icon-close q-mr-xs" />
            {{ $gettext("CALL_CLOSE") }}
          </q-btn>
        </div>
      </aside>

      <service-request-modal-search-consumer-unit
        :show="modalFinish"
        @input="(val) => (modalFinish = val)"
      />

    <q-dialog v-if="renderModal"  v-model="renderModal" full-height>
      <q-layout
        view="Lhh lpR fff"
        container
        full-height
        class="bg-white modal-large jtSearchOwnershipChangeContainer"
      >
        <q-header class="bg-primary">
          <q-toolbar>
            <q-toolbar-title>
              <translate >SEARCH</translate>
            </q-toolbar-title>
            <q-btn @click="() =>{renderModal = false }" flat round dense icon="close" />
          </q-toolbar>
        </q-header>

        <q-page-container class="full-height">
          <jt-dynamic-form
           v-if="data"
            ref="dynamicForm"
            :inputs="data.inputs"
            :relacionamentos="data.relacionamentos"
            :model="dadosFormSearch"
            :interface="data.nmInterface"
            form-class="form"
            class="q-pr-lg q-pl-lg q-py-lg"
            @search-found="selections"
            @composition-button-click="compositionButtonClick"
          />
        </q-page-container>
        <q-footer class="bg-white">
          <div class="row full-width q-col-gutter-lg justify-center q-py-lg">
            <div key="cancel" class="col-lg col-lg-2 col-md-3">
              <q-btn
                v-if="!detailMode"
                class="full-width cancel-btn"
                @click="() =>{renderModal = false }"
              >
                <translate>CANCEL</translate>
              </q-btn>
            </div>
            <div key="edit" class="col-lg-2 col-md-3">
              <q-btn
                class="full-width"
                color="positive"
                @click="search"
              >
                <translate>SEARCH</translate>
              </q-btn>
            </div>
          </div>
        </q-footer>

      </q-layout>
    </q-dialog>

    </main-content-layout>
  </main>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import { JtCrud, JtDynamicForm } from 'jtech-webcomps'
import { repository } from 'src/jtech/jtech-repository'
import ServiceRequestModel from '../ServiceRequestModel'
import ServiceRequestController from '../ServiceRequestController'
import ServiceRequestModalSearchConsumerUnit from './ServiceRequestModalSearchConsumerUnit'
import { QTable, QTd, QTr } from 'quasar'
const { form, input } = JtCrud
import MainContentLayout from './Layout/MainContentLayout.vue'
@Observer
@Component({
  name: 'ServiceRequestList',
  components: {
    ServiceRequestModalSearchConsumerUnit,
    'crud-form': form,
    'crud-input': input,
    QTable,
    QTd,
    QTr,
    MainContentLayout,
    JtDynamicForm
  },
  props: {
    protocol: String
  }
})
class ServiceRequestList extends Vue {
  state = ServiceRequestModel.getInstance();
  controller = ServiceRequestController.getInstance();

  nmInterfaceModel = 'serviceRequest.serviceRequest';
  nmInterfaceList = 'serviceRequest.list';
  form = {};
  colunasTabela = [];
  selected = [];
  pagination = {
    page: 1,
    rowsPerPage: 0
  };

  data = null;

  selectAll = false;
  modalFinish = false;

  renderModal= false
  dadosFormSearch = {}

  async mounted () {
    await this.reload({
      id: this.protocol
    })
  }

  onSelectedRow (itemsSelected) {
    this.selected = itemsSelected
  }

  async reload (params) {
    try {
      this.forms = await repository.resolve(this.nmInterfaceList, params)

      this.data = this.forms[0]
      this.colunasTabela = this.data.inputs.find(
        (i) => i.type === 'DATATABLE' || i.type === 'DATATABLE_FORM'
      ).columns

      this.forms = await repository.resolveForm(this.nmInterfaceModel, params)
      this.form = this.forms[0]
    } catch {
      console.error(
        `Interface: ${this.nmInterface}. There was an error when trying to load the form.`
      )
    }
  }

  printAddress (data) {
    var addressData = data.row.addresss.find(x => x.addressPersonType == 20030001)
    if (addressData) {
      var concatenatedAddress = [
        addressData.address,
        addressData.number,
        addressData.detail,
        addressData.neighborhood
      ].filter(Boolean).join(', ')
    }
    return concatenatedAddress
  }

  onSelectAllChangeHandler () {
    if (this.selectAll) {
      this.selected = this.dadosTabela
    } else {
      this.selected = []
    }
  }

  getLabelInput (nmPropriedade) {
    try {
      return (
        // eslint-disable-next-line no-undef
        _.find(this.form.inputs, function (input) {
          return input.model == nmPropriedade
        }).label + ':'
      )
    } catch (error) {}
    return nmPropriedade
  }

  onServiceRequest () {
    this.controller.getInfoCard(this.protocol, this.selected[0].id)
    this.controller.router({
      name: 'serviceRequest.consumer-unit',
      params: {
        protocol: this.protocol,
        consumerUnit: this.selected[0].id
      }
    })
  }

  onSearschServiceRequest () {
    this.modalFinish = true
  }

  async openFilterModal () {
    this.renderModal = true
  }

  async search () {
    await this.controller.load(this.protocol, this.state.serviceRequests[this.protocol], this.dadosFormSearch)
    this.renderModal = false
  }
}
export default ServiceRequestList
</script>
<style lang="scss" scoped>
@import "tailwindcss/utilities";

main {
  height: 93vh;
  display: flex;
  flex-direction: column;
}

.btn-header {
  display: flex;
  width: 200px;
  gap: 10px;
}

.btn-close-call {
  width: 330px;
  color: #C10015;
  border: 2px solid #C10015;
  background-color: #fff;
}

.btn-close-call:hover {
  overflow: hidden;
  background-color: #C10015 !important;
  color: #fff;
}

:deep(.q-table__container) {
  height: 100%;
}

:deep(.q-table__middle) {
  max-height: none !important;
}
</style>
